module.exports = __webpack_public_path__ + "img/HCMTX_common.427b22e6.png";